"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _providerComponents = require("@kyruus/provider-components");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _providerBadge = _interopRequireDefault(require("../ProviderBadge/provider-badge"));
var _styles = _interopRequireDefault(require("./styles"));
const ProviderBadges = _ref => {
  let {
    config,
    provider,
    badgeFields,
    intl
  } = _ref;
  // Get the badges for the provider
  const badges = (0, _providerComponents.getProviderBadgeFields)(provider, badgeFields);
  return /*#__PURE__*/_react.default.createElement(_styles.default, {
    "data-testid": "ProviderBadges"
  }, (0, _map.default)(badges).call(badges, badge => /*#__PURE__*/_react.default.createElement(_providerBadge.default, {
    key: badge.field,
    badge: badge
  })), (0, _providerComponents.displayBookOnlineBadge)(config, provider) && /*#__PURE__*/_react.default.createElement(_providerBadge.default, {
    badge: {
      label: intl.formatMessage(_messages.default.onlinebooking)
    }
  }), (0, _providerComponents.displayVirtualProviderBadge)(config, provider) && /*#__PURE__*/_react.default.createElement(_providerBadge.default, {
    badge: {
      label: intl.formatMessage(_messages.default.appointmentVideoTitle)
    }
  }), (0, _providerComponents.displayPhoneVisitBadge)(config, provider) && /*#__PURE__*/_react.default.createElement(_providerBadge.default, {
    badge: {
      label: intl.formatMessage(_messages.default.appointmentPhoneTitle)
    }
  }));
};
var _default = exports.default = (0, _intl.injectIntl)(ProviderBadges);
ProviderBadges.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderBadges"
};